import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style";
import assets from "./placeMarkerAssets.json";

// Assets mirror shared/places.js and Atlas placeCategoryUi's Lucide glyphs.
export function createPlaceMarkerStyle(placeType = "DELIVERY_POINT") {
  const meta = assets[placeType] || assets.DELIVERY_POINT;
  return [
    new Style({ image: new CircleStyle({ radius: 15, fill: new Fill({ color: meta.color }), stroke: new Stroke({ color: "#fff", width: 2 }) }), zIndex: 20 }),
    new Style({ image: new Icon({ src: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(meta.svg)}` }), zIndex: 21 }),
  ];
}
